import React from "react";
import '../css/GameConsentModal.css'
import { useNavigate } from "react-router-dom";

const GameConsentModal = ({ onAccept, onDecline }) => {


  const navigate = useNavigate()

  const handleAccept=()=>{

  }


  const handleDecline=()=>{
    
  }



  return (
    <div className="cptpl_page modal-overlay">
     <input type="hidden" value="20221206" name="cptpl_template" class="cptpl_template"/>

     {/* <input type="hidden" value="20251023" name="cptpl_template" class="test cptpl_template" />  */}
    <input type="hidden" value="" name="cptpl_landing_page_id" class="test  cptpl_landing_page_id  " />

      <div className="modal-card">
        <h2 className="modal-title">Content Services Blocked</h2>
        <p className="modal-subtext">
        Content Services are currently blocked. If you select 'ACCEPT' you will be allowed to purchase this specific content, but other content services will remain blocked.
     
        </p>
        <form >
          <button className="protected cptpl_subscribe modal-accept"  onClick={handleAccept}  type="button" >
          ACCEPT
        </button>
        <button className="protected cptpl_exit modal-decline" onClick={handleDecline}>
          DECLINE
        </button>
        </form>
        {/* <div className="modal-info">
          <p>Pay with Vodacom Add to Bill</p>
          <p>Dial *123*99# to cancel</p>
          <p>Contact: 0750-888-4445</p>
        </div> */}
        {/* <div className="modal-brand">
          <span role="img" aria-label="gamepad">🎮</span> Multi Fun
        </div> */}
      </div>
    </div>
  );
};

export default GameConsentModal;
